<template>
  <narrow-container>
    <div
      id="loading"
      :class="{'show':inProgress}"
    />
    <h1 class="headline-secondary text--center">
      {{ this.$i18n.t('PASSWORD_RESET.HEADER') }}
    </h1>
    <p>
      {{ this.$i18n.t('PASSWORD_RESET.P1') }}
    </p>
    <p>
      {{ this.$i18n.t('PASSWORD_RESET.P2') }}
    </p>
    <p>
      {{ this.$i18n.t('PASSWORD_RESET.P3') }}
    </p>
    <password-reset-pin
      ref="passwordResetPin"
    />
    <validated-input-box
      id="pinField"
      ref="pinField"
      :validation-reg-exp="pinRegex"
      :validation-error-message="$i18n.t('PASSWORD_RESET.PIN_INVALID')"
      :label="this.$i18n.t('PASSWORD_RESET.PIN')"
      name="pinField"
    />
    <selfcare-password-input
      id="newPasswordField"
      ref="newPasswordField"
      name="newPasswordField"
      :label1="this.$i18n.t('PASSWORD_RESET.PASSWORD')"
      :label2="this.$i18n.t('PASSWORD_RESET.PASSWORD_REPEAT')"
      :mandatory="true"
    />
    <submit-button
      id="passwordResetSubmitButton"
      :label="this.$i18n.t('PASSWORD_RESET.NEXT')"
      :on-click="resetPassword"
      :disabled="!frcResponse"
    />
    <friendly-captcha-field
      ref="captcha"
      v-model="frcResponse"
    />
  </narrow-container>
</template>

<script>
import Regex from '@/constants/regex.json';
import PasswordResetPin from "@/views/login/PasswordResetPin";
import FriendlyCaptchaField from '@/components/common/FriendlyCaptchaField.vue';

const RESP_VALIDATION_ERROR = 1;
const RESP_MSISDN_NOT_PREPAID = 2;
const RESP_PASSWORD_INCORRECT = 3;
const RESP_TEMPORARILY_LOCKED = 4;
const RESP_LOCKED = 5;
const RESP_NOT_YET_REGISTERED = 6;
const RESP_PIN_TIME_PROTECTION = 7;
const RESP_PIN_INCORRECT = 8;
const RESP_PIN_EXPIRED = 9;
const RESP_PIN_LOCKED_TEMPORARILY = 10;
const RESP_PIN_LOCKED = 11;
const RESP_OTHER_ERROR = 9999;

export default {
  name: 'PasswordReset',
  components: { PasswordResetPin, FriendlyCaptchaField },
  data: function() {
    return {
      inProgress: false,
      passwordsMatch: true,
      isMounted: false,
      frcResponse: null,
    };
  },
  computed: {
    pinRegex: function() {
      return Regex.PIN;
    },
  },
  mounted: function(){
    this.isMounted = true;
  },
  methods: {
    isFormValid: function() {
      const isValid = this.$refs.passwordResetPin.getLoginField().isValidBeforeSubmit()
        && this.$refs.pinField.isValidBeforeSubmit()
        && this.$refs.newPasswordField.isValidBeforeSubmit();
      return isValid;
    },
    processErrorCallResponse: function(callData) {
      if(callData.response === undefined || callData.response.data === undefined) {
        this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
        this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - no data', value: 0, noninteraction: false });
        return;
      }

      let responseCode = callData.response.data.responseCode;

      switch(responseCode) {
        case RESP_VALIDATION_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.VALIDATION_ERROR'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - validation', value: 0, noninteraction: false });
          break;
        case RESP_MSISDN_NOT_PREPAID:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.MSISDN_NOT_ACTIVE_PREPAID'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - not active prepaid', value: 0, noninteraction: false });
          break;
        case RESP_TEMPORARILY_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_TEMPORARILY_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - temporarily locked', value: 0, noninteraction: false });
          break;
        case RESP_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.LOGIN_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - locked', value: 0, noninteraction: false });
          break;
        case RESP_NOT_YET_REGISTERED:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.SUBSCRIPTION_NOT_YET_REGISTERED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - not registered', value: 0, noninteraction: false });
          break;
        case RESP_PIN_TIME_PROTECTION:
          this.$store.commit("setErrorMessage", this.$i18n.t('PASSWORD_RESET.ERROR_MESSAGES.PIN_TIME_PROTECTION'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - PIN time protection', value: 0, noninteraction: false });
          break;
        case RESP_PIN_INCORRECT:
          this.$store.commit("setErrorMessage", this.$i18n.t('PASSWORD_RESET.ERROR_MESSAGES.PIN_INCORRECT'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - PIN incorrect', value: 0, noninteraction: false });
          break;
        case RESP_PIN_EXPIRED:
          this.$store.commit("setErrorMessage", this.$i18n.t('PASSWORD_RESET.ERROR_MESSAGES.PIN_EXPIRED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - PIN expired', value: 0, noninteraction: false });
          break;
        case RESP_PIN_LOCKED_TEMPORARILY:
          this.$store.commit("setErrorMessage", this.$i18n.t('PASSWORD_RESET.ERROR_MESSAGES.PIN_TEMPORARILY_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - PIN temporarily locked', value: 0, noninteraction: false });
          break;
        case RESP_PIN_LOCKED:
          this.$store.commit("setErrorMessage", this.$i18n.t('PASSWORD_RESET.ERROR_MESSAGES.PIN_LOCKED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - PIN locked', value: 0, noninteraction: false });
          break;
        case RESP_OTHER_ERROR:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - technical issue', value: 0, noninteraction: false });
          break;
        default:
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Error - '+responseCode, value: 0, noninteraction: false });
      }
    },
    resetPassword: function() {
      if (!this.inProgress && this.isFormValid() && this.$refs.captcha.isValid()) {
        this.inProgress = true;
        const passwordResetRequest = {
          msisdn: this.$refs.passwordResetPin.getLoginField().getFieldValue(),
          pin: this.$refs.pinField.getFieldValue(),
          newPassword: this.$refs.newPasswordField.getFieldValue(),
        };
        this.$http.post('api/protected/passwordReset', passwordResetRequest, {
          headers: {
            'friendly-captcha-version': 'v2',
            'friendly-captcha-response': this.frcResponse
          }
        })
          .then( () => {
            this.processSuccessfulCallResponse();
          })
          .catch(callData => {
            this.processErrorCallResponse(callData);
            this.$refs.captcha.reset();
          })
          .finally(() => {
            this.inProgress = false;
          })
      }
    },
    processSuccessfulCallResponse: function() {
      this.$router.push({name: 'landing'});
      this.$store.commit("setSuccessMessage", this.$i18n.t('PASSWORD_RESET.SUCCESS'));
      this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'Password reset',label: 'Success', value: 0, noninteraction: false });
    },
  }
};
</script>

<style lang="scss" src="@/components/loading/loading.scss">
</style>
